// Deploy-skew recovery. Every deploy replaces the hashed /assets files, so
// a tab still running the previous build 404s when it lazy-loads a route
// chunk ("Failed to fetch dynamically imported module"). Vite fires
// `vite:preloadError` on the failed import — hard-reload into the new
// build, rate-limited so a genuinely broken deploy can't reload-loop.
const RELOAD_STAMP = 'govcrm:chunk-reload-at'

export function installFreshness() {
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault()
    const last = Number(sessionStorage.getItem(RELOAD_STAMP) ?? 0)
    if (Date.now() - last > 15_000) {
      sessionStorage.setItem(RELOAD_STAMP, String(Date.now()))
      window.location.reload()
    }
  })
}
